// 10mb
export const MAX_ATTACHMENT_SIZE = 10000000;

export const ACCEPTED_FILE_TYPES = ['image/jpeg', 'image/png', 'image/heic', 'application/pdf'];

export const isValidFileSize = (file: File): boolean => file.size <= MAX_ATTACHMENT_SIZE;
